function turnOn() {
    var cf = $('#inline');

    if(cf) {

        //cf.attr("href", "#inline");



        $("#checkout").bind("click", function(e) {


            if( $('#selected-partner').val().length == 0 ) {
                e.preventDefault();
                cf.fancybox().click();
                //$("#cart_form").addClass('submit-' + $(this).attr('type'));
                return false;
            }

        });



    }
}

function postalLookup(e) {
    e.preventDefault();
    if( $('#postal').val().length == 0 ) return;

    $('#postal-submit').text("Searching...").attr("disabled", "disabled");
    $.ajax( {
        url: 'https://wheretobuy.graytools.com/_storesXML/api.cfm',
        type: 'post',
        data: { postal: $('#postal').val() },
        dataType: 'jsonp',
        success: function(response) {
            $("#contact").hide();
            $('#postal-results').html("");
          	$("#postal-results").show();
          
            var select = '<h6 class="mb-2">Please select a store:</h6><select id="partner-select">';
            select += "<option>Please Select</option>";
            $(response).each(function(index, item) {

                select += "<option>" + item.name + ' - ' + item.city + ' - ' + item.address + ' - ' + item.postal + "</option>";
            });
            select += "</select><button id='partner-submit' class='action_button btn btn-1'>Submit</button><br /><p></p>";

            $('#postal-results').append(select);



            $('#postal-submit').text("Submit").attr("disabled", "");
            //$.fancybox.update();

            $('#partner-submit').attr('disabled','disabled');
            $('#partner-submit').css('visibility','hidden');


            $('#partner-select').change(function () {
                if ($(this).find("option:selected").text() == "Please Select") {

                    $('#partner-submit').attr('disabled','disabled');
                    $('#partner-submit').css('visibility','hidden');



                } else {

                    $('#partner-submit').removeAttr('disabled');
                    $('#partner-submit').css('visibility','visible');

                }
            });

            $('body').on('click','#partner-submit', function(e) {
              
                $('#selected-partner').val($('#partner-select').val());
                $.fancybox.close();
                $('#postal-results').html("");
                $("#postal-results").hide();


                $("#checkout").unbind("click");

                $('#checkout').click();

                /*
                 if ($('#cart_form').hasClass('submit-submit')) {
                 $(".submit-cart input[type='submit']").click();
                 } else {
                 $(".submit-cart input[type='image']").click();
                 }
                 */
                //$('#checkout').attr('data-fancybox-href','').click();
            });

        },
        error: function(e, text) {
            alert("Error:" + text);
        }
    });
}

$(document).ready(function(e) {
    if( false == true ) {
        turnOn();
    }
    //
    $('#postal-submit').click(postalLookup);

});